module.exports = __webpack_public_path__ + "media/assets/certification_page/cp-fc6cf677e393baea35790852635fff975b51a406b0e497e8cf4f3df26e7eb770.svg";